import { render, staticRenderFns } from "./authRedirect.vue?vue&type=template&id=91c74f7c"
import script from "./authRedirect.vue?vue&type=script&lang=js"
export * from "./authRedirect.vue?vue&type=script&lang=js"
import style0 from "./authRedirect.vue?vue&type=style&index=0&id=91c74f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports